import React from 'react'
import { news } from '../data/siteData'
import ImageWithFallback from '../components/ImageWithFallback'

const News = () => {
  return (
    <div className="News">
      <section className="relative py-24 bg-gradient-to-r from-primary-600 to-accent-600">
        <div className="container-custom">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Actualités
            </h1>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((article) => (
              <article key={article.id} className="card group cursor-pointer hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="relative overflow-hidden">
                  <ImageWithFallback
                    src={article.image}
                    alt={article.title}
                    className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-4 py-2 bg-gradient-to-r from-primary-500 to-primary-600 text-white text-xs font-semibold rounded-full shadow-lg backdrop-blur-sm">
                      {article.category}
                    </span>
                  </div>
                  
                  {/* Date badge */}
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-lg">
                    <div className="text-center">
                      <div className="text-sm font-bold text-gray-900">
                        {new Date(article.date).getDate()}
                      </div>
                      <div className="text-xs text-gray-600 uppercase">
                        {new Date(article.date).toLocaleDateString('fr-FR', { month: 'short' })}
                      </div>
                    </div>
                  </div>
                  
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-3 group-hover:text-primary-600 transition-colors duration-300">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{article.excerpt}</p>
                  
                  {/* Read more link */}
                  <div className="mt-4">
                    <span className="text-primary-600 font-semibold text-sm hover:text-primary-700 transition-colors duration-300 cursor-pointer">
                      Lire la suite →
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default News 